export default __webpack_public_path__ + "media/images/theme/bg_dark-fdb239f2c69172fc9ecf07cbe18af375.png";